import { create } from 'zustand';
import type { PlcSourceEncoding } from '../types';

export type ActivityPanelMode = 'preview';

export interface ActivityPanelState {
  isOpen: boolean;
  mode: ActivityPanelMode;
  filename: string;
  content: string;
  /** The encoding the file's turn recorded, which a .scl downloads in (utf8_bom when absent). */
  sclEncoding?: PlcSourceEncoding;
  previewDownload?: () => void | Promise<void>;
}

interface ActivityPanelActions {
  /** Open a code, Markdown, or text artifact in the shared right activity area. */
  open: (
    filename: string,
    content: string,
    sclEncoding?: PlcSourceEncoding,
    previewDownload?: () => void | Promise<void>,
  ) => void;
  close: () => void;
  updateContent: (content: string) => void;
}

const CLOSED_STATE: ActivityPanelState = {
  isOpen: false,
  mode: 'preview',
  filename: '',
  content: '',
  sclEncoding: undefined,
  previewDownload: undefined,
};

export const useFilePreviewStore = create<ActivityPanelState & ActivityPanelActions>((set, get) => ({
  ...CLOSED_STATE,

  open: (filename, content, sclEncoding, previewDownload) => {
    set({
      ...CLOSED_STATE,
      isOpen: true,
      mode: 'preview',
      filename,
      content,
      sclEncoding,
      previewDownload,
    });
  },

  close: () => {
    set(CLOSED_STATE);
  },

  updateContent: (content) => {
    if (get().isOpen && get().mode === 'preview') set({ content });
  },
}));
